export default "__VITE_ASSET__nLOLM8z4__"